import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useEffect, useRef } from "react";
import TrackingPage from "./TrackingPage";
import "./styles/index.scss";
import { getLocaleMenu } from "./stores/ContentState";

const App = () => {
  const headerContent = useRef(null);
  useEffect(() => {
    getLocaleMenu();
  }, []);

  return (
    <Router>
      <div ref={headerContent}></div>
      <Routes>
        <Route path={"/:lang/track"} element={<TrackingPage />} />
        <Route path={"/track"} element={<TrackingPage />} />
      </Routes>
    </Router>
  );
};

export default App;
